import React, { useEffect, useRef, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import { pubCall } from "../utils/PubSub";
import Input from "../ui/Input";
import { KBD } from "../utils/Keybindings";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { listen } from "../hooks/Listener";


export default function OrderFilter(props) {

    const { controller = "", route = "", callback = () => {}, setData = () => {}, setSelected = () => {} } = props;
    const offsetRef = useRef(100);
    const [ loading, setLoading ] = useState(false);

    const defaultTabs = [

        { key: "order_status", value: "B", skip: false},
        { key: "nyr_titles", value: "E", skip: false},
        { key: "standing_orders", value: "I", skip: false},
        { key: "shipped_orders", value: "I", skip: false},
        { key: "order_age", value: 0, skip: false},
        { key: "customer_type", value: "", skip: false},
        { key: "clerk_codes", value: "", skip: false},

    ];

    const searchFilter = () => {
        let _filters = {};
        _filters.limit = 100;

        tabs.forEach(element => {
            const currentRef = refs?.current?.[element.key];
            let currentValue = currentRef?.value !== undefined ? currentRef.value : element.value;
            
            if (element.key === "order_age") {
                currentValue = parseInt(currentValue);
            }
            
            _filters[element.key] = currentValue;
        })
        
        if (!_filters.customer_type) {
            delete _filters.customer_type;
        }
        if (!_filters.clerk_codes) {
            delete _filters.clerk_codes;
        }
        
        pubCall("order.searchByFiltered", _filters, (_s, _r) => {
            if (_s) {
                setData(_r.rows);
                setSelected((_r.rows.length > 0) ? _r.rows[0] : {});
                callback(false);
            }
        })
    }

    const { tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs } = useTabs(defaultTabs, "order_status");

    const tabsRef = useRef(tabs);

    const onEdit = (fieldKey) => {
        if (fieldKey) {
            requestAnimationFrame(() => {
                setIndex(fieldKey);
            });
        }
    }

    useEffect(() => {
        tabsRef.current = tabs;
    }, [tabs]);

    // Keyboard Events
    useEffect(() => {

        if (refs?.current?.[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ARROW_DOWN, action: (e) => { next() } },
            { key: KBD.ARROW_UP, action: (e) => { prev() } },
            { key: KBD.PAGE_DOWN, action: (e) => { searchFilter(); } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ESCAPE, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [index, loading]);

    const statuses = {
        order_status: "Listing is restricted to only entries matching search.",
        nyr_titles: "Filter orders with PubDates in the future",
        standing_orders: "Filter STANDING magazine orders (i.e. CustPO = STANDING)",
        shipped_orders: "Filter orders with a status of 'Ship'",
        order_age: "0 for today, 999 for oldest active order",
        customer_type: "",
        clerk_codes: "",
    }


    return (
        <Spin style={{ "margin": "0px -10px" }} loading={loading}>
            
            <div style={{ "width": "500px", "padding": "0px 10px" }}>

                <div className="shim" /><div className="shim" /><div className="shim" />

                <Space height={25} size={10}>
                    <Input {...editProps("order_status")} chars={["P", "O", "B"]} tabMax={() => next()} uppercase maxLength={1} width={10} className={(index !== "order_status") ? "dim" : ""} />
                    <Label className={(index === "order_status") ? "selected" : ""}>[P]ending [O]rdered [B]oth</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("nyr_titles")} chars={["I", "E", "M"]} tabMax={() => next()} uppercase maxLength={1} width={10} className={(index !== "nyr_titles") ? "dim" : ""} />
                    <Label className={(index === "nyr_titles") ? "selected" : ""} >NYR titles [I]nclude [E]xclude [M]andatory </Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("standing_orders")} chars={["I", "E", "M"]} tabMax={() => next()} uppercase maxLength={1} width={10} className={(index !== "standing_orders") ? "dim" : ""} />
                    <Label className={(index === "standing_orders") ? "selected" : ""}>STANDING orders [I]nclude [E]xclude [M]andatory </Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("shipped_orders")} chars={["I", "E", "M"]} tabMax={() => next()} uppercase maxLength={1} width={10} className={(index !== "shipped_orders") ? "dim" : ""} />
                    <Label className={(index === "shipped_orders") ? "selected" : ""}>SHIPed orders [I]nclude [E]xclude [M]andatory </Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("order_age")} number maxLength={3} width={35} className={(index !== "order_age") ? "dim" : ""}  />
                    <Label className={(index === "order_age") ? "selected" : ""}>order age (to start from)</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("customer_type")} maxLength={10} width={100} className={(index !== "customer_type") ? "dim" : ""}  />
                    <Label className={(index === "customer_type") ? "selected" : ""}>customer type</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Input {...editProps("clerk_codes")} maxLength={200} width={200} className={(index !== "clerk_codes") ? "dim" : ""}  />
                    <Label className={(index === "clerk_codes") ? "selected" : ""}>clerk codes (comma separated)</Label>
                </Space>

                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                <div style={{ "backgroundColor": "var(--console-bg)", "margin": "-10px -10px", "borderTop": "2px solid var(--border-secondary)", "padding": "10px", "borderBottomLeftRadius": "5px", "borderBottomRightRadius": "5px" }}>
                    <Status><InfoIcon /> {statuses[index]}</Status>
                </div>
            </div>
        </Spin>
    )

}